/**
 * @generated SignedSource<<ea0ab5d6e00d055f01abfb09a25ec9c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppGoogleSSO_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly googleSSOEnabled: boolean | null;
  } | null;
  readonly " $fragmentType": "AppGoogleSSO_viewer";
};
export type AppGoogleSSO_viewer$key = {
  readonly " $data"?: AppGoogleSSO_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppGoogleSSO_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppGoogleSSO_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "googleSSOEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "ad7f9b73cd761dd4203c64123c67abb1";

export default node;
